"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _utils = require("@seedlang/utils");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var CaseFillInTheBlanksCardWrapper = function CaseFillInTheBlanksCardWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _this.filterIncorrectForms = function (forms, correctAnswer) {
        return forms.filter(function (form) {
          return form && form.toLowerCase() !== correctAnswer.toLowerCase();
        });
      };
      _this.getIncorrectFormsFromChildWords = function (rootWord, correctAnswer) {
        if (!rootWord.childWordsList) return [];
        var allForms = rootWord.childWordsList.split(',').map(function (form) {
          return form.trim();
        });
        return _this.filterIncorrectForms(allForms, correctAnswer);
      };
      _this.getDeclensionFormsFromList = function (rootWord, correctAnswer) {
        var forms = [];
        if (_constants.DECLENSION_OPTIONS[rootWord.targetText]) {
          var declensionForms = _constants.DECLENSION_OPTIONS[rootWord.targetText];
          forms = _this.filterIncorrectForms(declensionForms, correctAnswer);
        }
        if (forms.length < 3) {
          var neededForms = 3 - forms.length;
          var allDeclensionForms = _this.filterIncorrectForms(Object.values(_constants.DECLENSION_OPTIONS), correctAnswer).filter(function (form) {
            return !forms.includes(form);
          });
          var shuffledForms = _toConsumableArray(allDeclensionForms).sort(function () {
            return Math.random() - 0.5;
          });
          var additionalForms = shuffledForms.slice(0, neededForms);
          forms = [].concat(_toConsumableArray(forms), _toConsumableArray(additionalForms));
        }
        return forms;
      };
      _this.generatePatternBasedForms = function (rootWord, correctAnswer, existingForms) {
        var baseForm = rootWord.targetText;
        var stem = baseForm.endsWith('e') ? baseForm.slice(0, -1) : baseForm;
        var generatedForms = [baseForm, "".concat(stem, "e"), "".concat(stem, "en"), "".concat(stem, "es"), "".concat(stem, "er"), "".concat(stem, "em")];
        return _this.filterIncorrectForms(generatedForms, correctAnswer).filter(function (form) {
          return !existingForms.includes(form);
        });
      };
      _this.selectRandomIncorrectOptions = function (incorrectForms) {
        var uniqueIncorrectForms = _toConsumableArray(new Set(incorrectForms));
        var shuffledIncorrect = uniqueIncorrectForms.sort(function () {
          return Math.random() - 0.5;
        });
        return shuffledIncorrect.slice(0, 3);
      };
      _this.createOptionsArray = function (correctAnswer, selectedIncorrect) {
        var options = [{
          id: correctAnswer,
          label: correctAnswer,
          correct: true
        }].concat(_toConsumableArray(selectedIncorrect.map(function (form) {
          return {
            id: form,
            label: form,
            correct: false
          };
        })));
        return options.sort(function () {
          return Math.random() - 0.5;
        });
      };
      _this.onSelectWordForm = function (wordFormItem) {
        var cardState = _this.props.cardState;
        if (cardState.revealed || cardState.pendingReveal) return;
        cardState.selectedOptionText = wordFormItem.label;
        clearTimeout(_this.checkAnswerTimeout);
        _this.checkAnswerTimeout = setTimeout(function () {
          if (_this.props.cardState === cardState) _this.onCheckAnswerMultipleChoice();
        }, 100);
      };
      _this.onCheckAnswerMultipleChoice = function () {
        if (_this.props.cardState.revealed || !_this.selectedWordForm) return;
        if (_this.isMultipleChoiceCorrect) {
          _state.DeckUI.onCorrectAnswer(_this.props.card, _this.props.cardState, _this.props.userCard, {
            xp: 2,
            xpSlug: 'case'
          });
        } else {
          _state.DeckUI.onIncorrectAnswer(_this.props.card, _this.props.cardState, _this.props.userCard);
        }
        _state.DeckUI.reveal(_this.props.card, _this.props.cardState);
      };
      _this.onNextClick = function () {
        _state.DeckUI.advanceCard(_this.props.card, _this.props.cardState, _this.props.userCard);
      };
      _this.removeOnboardingTips = function () {
        if (_this.currentArrowBox) {
          _state.DeckUI.designateUiElementAsSeen(_this.currentArrowBox.slug);
        }
      };
      _state.DeckUI.enrichSentence(_this.props.card);
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "selectedWordForm",
      get: function get() {
        return this.props.cardState.selectedOptionText;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        clearTimeout(this.checkAnswerTimeout);
      }
    }, {
      key: "numSections",
      get: function get() {
        return this.props.cardState.revealed ? 3 : 2;
      }
    }, {
      key: "sectionHeight",
      get: function get() {
        return this.props.cardState.revealed ? _state.DeckUI.layout.heightForCardSections(this.numSections, 0, false) : _state.DeckUI.layout.contentHeightWithMultipleChoiceButtons(4) / this.numSections;
      }
    }, {
      key: "selectedWord",
      get: function get() {
        var _this$props$card$sent,
          _this$props$card$sent2,
          _this2 = this;
        if (!((_this$props$card$sent = this.props.card.sentence) !== null && _this$props$card$sent !== void 0 && _this$props$card$sent.wordAssociations)) return null;
        return (_this$props$card$sent2 = this.props.card.sentence.wordAssociations.find(function (wa) {
          return _this2.props.card.wordAssociationIds.includes(wa.id);
        })) === null || _this$props$card$sent2 === void 0 ? void 0 : _this$props$card$sent2.word;
      }
    }, {
      key: "correctAnswer",
      get: function get() {
        var _this$props$card$sent3,
          _this3 = this;
        if (!((_this$props$card$sent3 = this.props.card.sentence) !== null && _this$props$card$sent3 !== void 0 && _this$props$card$sent3.wordAssociations)) return '';
        var targetWordAssociation = this.props.card.sentence.wordAssociations.find(function (wa) {
          return _this3.props.card.wordAssociationIds.includes(wa.id);
        });
        return (targetWordAssociation === null || targetWordAssociation === void 0 ? void 0 : targetWordAssociation.targetText) || '';
      }
    }, {
      key: "topSectionText",
      get: function get() {
        if ((0, _utils.isPresent)(this.props.card.prompt)) {
          return this.props.card.prompt;
        } else if ((0, _utils.isPresent)(this.props.card.sentence)) {
          return this.props.card.sentence.sourceTextForUser(_state.DeckUI.user);
        }
      }
    }, {
      key: "topSectionLanguageId",
      get: function get() {
        if ((0, _utils.isPresent)(this.props.card.sentence)) {
          return this.props.card.sentence.sourceTextForUserLanguageId(_state.DeckUI.user);
        }
      }
    }, {
      key: "wordFormOptions",
      get: function get() {
        var _this$selectedWord$wo;
        if (!this.selectedWord) return [];
        var rootWord = this.selectedWord.selfOrRoot;
        if (!rootWord) return [];
        var correctAnswer = this.correctAnswer;
        var wordType = (_this$selectedWord$wo = this.selectedWord.wordType) === null || _this$selectedWord$wo === void 0 ? void 0 : _this$selectedWord$wo.abbreviation;
        var incorrectForms = [];
        if ((0, _utils.isPresent)(wordType)) {
          if (wordType !== null && wordType !== void 0 && wordType.startsWith('art') || wordType !== null && wordType !== void 0 && wordType.startsWith('pron')) {
            incorrectForms = this.getDeclensionFormsFromList(rootWord, correctAnswer);
          } else {
            incorrectForms = this.getIncorrectFormsFromChildWords(rootWord, correctAnswer);
          }
          if (incorrectForms.length < 3) {
            var neededForms = 3 - incorrectForms.length;
            var generatedForms = this.generatePatternBasedForms(rootWord, correctAnswer, incorrectForms);
            var shuffledGenerated = _toConsumableArray(generatedForms).sort(function () {
              return Math.random() - 0.5;
            });
            var selectedGeneratedForms = shuffledGenerated.slice(0, neededForms);
            incorrectForms = [].concat(_toConsumableArray(incorrectForms), _toConsumableArray(selectedGeneratedForms));
          }
          var selectedIncorrect = this.selectRandomIncorrectOptions(incorrectForms);
          return this.createOptionsArray(correctAnswer, selectedIncorrect);
        } else {
          return [];
        }
      }
    }, {
      key: "isMultipleChoiceCorrect",
      get: function get() {
        return this.selectedWordForm === this.correctAnswer;
      }
    }, {
      key: "correctCase",
      get: function get() {
        if (!this.selectedWord) return null;
        if (this.selectedWord.isNominative) return 'nominative';
        if (this.selectedWord.isGenitive) return 'genitive';
        if (this.selectedWord.isDative) return 'dative';
        if (this.selectedWord.isAccusative) return 'accusative';
        return null;
      }
    }, {
      key: "grammarHint",
      get: function get() {
        return _state.DeckUI.getCaseGrammarHint(this.props.card, this.props.cardState);
      }
    }, {
      key: "possibleArrowBoxes",
      get: function get() {
        var boxes = [];
        if (!_state.DeckUI.user.textInputCaseTrainer) {
          boxes.push('toggleCaseInputMode');
        }
        boxes.push('caseConcept');
        return boxes;
      }
    }, {
      key: "currentArrowBox",
      get: function get() {
        var arrowBox;
        if (!this.props.cardState.revealed) {
          (0, _lodash.each)(this.possibleArrowBoxes, function (slug) {
            if (!_state.DeckUI.user.wasUiElementSeen(slug)) {
              arrowBox = slug;
            }
          });
        }
        return arrowBox;
      }
    }, {
      key: "icons",
      get: function get() {
        var _this$props$card;
        var ary = [];
        if (_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (!_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('toggleReview');
        }
        if (this.props.cardState.revealed) {
          ary.push('cardComments');
        }
        if (_state.DeckUI.reviewDeck && (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal)) {
          ary.push('cardNote');
        }
        if (!this.props.cardState.revealed) {
          ary.push('toggleMultipleChoice');
        }
        if ((0, _utils.isPresent)((_this$props$card = this.props.card) === null || _this$props$card === void 0 || (_this$props$card = _this$props$card.concept) === null || _this$props$card === void 0 ? void 0 : _this$props$card.longDescription)) {
          ary.push('caseDescription');
        }
        return ary;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          blockEvaluateVocabOnKeystroke: true,
          numSections: this.numSections,
          sectionHeight: this.sectionHeight,
          correctAnswer: this.correctAnswer,
          icons: this.icons,
          showCase: true,
          hideTextInput: true,
          topSectionText: this.topSectionText,
          topSectionLanguageId: this.topSectionLanguageId,
          wordFormOptions: this.wordFormOptions,
          selectedWordForm: this.selectedWordForm,
          highlightCorrectAnswer: this.props.cardState.revealed && this.isMultipleChoiceCorrect,
          onSelectWordForm: this.onSelectWordForm,
          onNextClick: this.onNextClick,
          correctCase: this.correctCase,
          grammarHint: this.grammarHint,
          currentArrowBox: this.currentArrowBox,
          possibleArrowBoxes: this.possibleArrowBoxes,
          alwaysShowTextInput: true
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "selectedWordForm", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedWordForm"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "numSections", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "numSections"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "sectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "sectionHeight"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "selectedWord", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedWord"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "topSectionText", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "topSectionText"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "topSectionLanguageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "topSectionLanguageId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "wordFormOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "wordFormOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isMultipleChoiceCorrect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isMultipleChoiceCorrect"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctCase", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctCase"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "grammarHint", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "grammarHint"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "possibleArrowBoxes", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "possibleArrowBoxes"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "currentArrowBox", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "currentArrowBox"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _class2)) || _class;
};
CaseFillInTheBlanksCardWrapper.displayName = 'CaseFillInTheBlanksCardWrapper';
var _default = exports["default"] = CaseFillInTheBlanksCardWrapper;